<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户信息</el-breadcrumb-item>
      <el-breadcrumb-item>密码修改</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-form ref="form" :model="form" :rules="formRules" label-width="150px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="form.oldPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="form.newPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="newPassword1">
          <el-input v-model="form.newPassword1" type="password"></el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="changepassword">保存修改</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  created () {

  },
  data () {
    // 验证两次密码是否一致
    var checkPassword = (rule, value, cb) => {
      if (this.form.newPassword === value) {
        // 合法的邮箱
        return cb()
      }

      cb(new Error('两次输入的密码不一致'))
    }

    return {
      form: {
        oldPassword: '',
        newPassword: '',
        merchantPhone: ''
      },
      // 表单验证规则
      formRules: {
        oldPassword: [
          { required: true, message: '原密码不能为空', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '新密码不能为空', trigger: 'blur' }],
        newPassword1: [
          { required: true, message: '确认新密码不能为空', trigger: 'blur' },
          { validator: checkPassword }]
      }

    }
  },
  methods: {
    // 保存密码修改
    async changepassword () {
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') { // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      // 获取merchantId
      const merchantId = window.sessionStorage.getItem('merchantId')
      if (undefined === merchantId || merchantId === '') { // 判断merchantId是否存在
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      // 请求修改密码
      const { data: res } = await this.$http.get('updateMerchantPassWord', {
        headers: { token: token },
        params: { merchantId: merchantId, oldPassword: this.form.oldPassword, newPassword: this.form.newPassword }
      })
      if (res.code === '0') {
        this.$message.success('密码修改成功')
        var that = this
        setTimeout(function () {
          window.sessionStorage.clear()
          that.$router.push('/merlogin')
        }, 1500)
      } else {
        return this.$message.error(res.message)
      }
    }
  },
  computed: {}
}
</script>

<style lang="less" scoped>
</style>
